export default __webpack_public_path__ + "static/media/euCisoo.d9eb82c0.png";